<template>
  <div>
    <auth-title label="Login" />

    <auth-step-switcher
      label="Noch kein Account? <u>Registrieren Sie sich bitte kostenlos.</u>"
      @click="$emit('update', 'currentStep', 'registration')"
    />

    <auth-group>
      <auth-input
        style="width: 15em"
        type="email"
        name="username"
        label="E-Mail-Adresse"
        v-model="value.username"
        :error="error.username"
        @input="updateValue"
      />

      <auth-input
        style="width: 15em"
        type="password"
        name="password"
        label="Passwort"
        v-model="value.password"
        :error="error.password"
        @input="updateValue"
        :description="passwordDescription"
      />
    </auth-group>

    <auth-agb-privacy-info :agbUrl="agbUrl" :privacyUrl="privacyUrl" />

    <auth-captcha :state="state" @update="update" />

    <auth-group>
      <auth-button
        v-if="onPrev"
        label="ZURÜCK"
        @click="() => onPrev()"
        is-prev-button
      />
      <auth-button
        v-if="state.currentStep === 'login'"
        label="WEITER"
        @click="submit"
      />
    </auth-group>
  </div>
</template>

<script>
import Api from "../api/api";
import Validator, { emailRegex } from "./validator";
import AuthTitle from "@/components/plenigo-auth-v2/components/auth-title";
import AuthStepSwitcher from "@/components/plenigo-auth-v2/components/auth-step-switcher";
import AuthInput from "@/components/plenigo-auth-v2/components/auth-input";
import AuthAgbPrivacyInfo from "@/components/plenigo-auth-v2/components/auth-agb-privacy-info";
import AuthCaptcha from "@/components/plenigo-auth-v2/components/auth-captcha";
import AuthButton from "@/components/plenigo-auth-v2/components/auth-button";
import AuthGroup from "@/components/plenigo-auth-v2/components/auth-group";
import helper from "../helper/helper";

export default {
  props: {
    state: Object,
    afterLoginUpdate: Boolean,
    passwordResetUrl: String,
    agbUrl: String,
    privacyUrl: String,
    onPrev: Function
  },
  components: {
    AuthGroup,
    AuthTitle,
    AuthStepSwitcher,
    AuthInput,
    AuthAgbPrivacyInfo,
    AuthCaptcha,
    AuthButton
  },
  data() {
    return {
      value: {
        username: this.state.value && this.state.value.username,
        password: this.state.value && this.state.value.password
      },
      error: {
        username: false,
        password: false
      },
      errorMessage: null
    };
  },
  methods: {
    update(property, value) {
      this.$emit("update", property, value);
    },
    async submit() {
      this.update("errorMessage", undefined);
      if (
        !Validator.validate(
          {
            username: emailRegex,
            password: /^.{8,}$/
          },
          this.value,
          this.error
        )
      ) {
        return;
      }

      const login = await Api.login({
        ...this.value,
        optin_privacy: true
      });

      if (!login.success) {
        this.update("errorMessage", login.message);
        return;
      }
      helper.firstConfirm();

      this.updateValue();

      const userPersonalData = await Api.userPersonalData({
        username: this.value.username
      });
      const data = userPersonalData.personaldata || {};
      this.update("value", {
        ...this.value,
        salutation: data.gender === "MALE" ? "Herr" : "Frau",
        lastname: data.lastname,
        firstname: data.firstname,
        zip: data.postcode,
        city: data.city,
        street: data.street,
        streetnumber: data.streetnumber
      });

      this.update("currentStep", this.afterLoginUpdate ? "update" : "finished");
    },
    updateValue() {
      this.update("value", this.value);
    }
  },
  computed: {
    passwordDescription() {
      return (
        this.passwordResetUrl &&
        `<a target="_blank" href="${this.passwordResetUrl}" class="mod mod--style--normal mod--theme--primary mod--size--14 mod--weight--400">Passwort vergessen</a>`
      );
    }
  }
};
</script>
